export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12009.157feeb8.jpg";